export default {
  en: {
    betaAlertTitle: 'Feature in beta',
    betaAlertDescription: 'The custom templates feature is in beta status, which means the documentation may not be fully available, but it is stable and secure in operation.',
    form: {
      name: {
        label: 'Template name',
        hint: 'Internal template name',
        placeholder: 'Enter a template name',
      },
      slug: {
        label: 'Integration id',
        hint: 'Integration id to operate with Webhooks',
        placeholder: 'Enter a integration id'
      },
      template: {
        label: 'Template to customize',
        hint: 'This will be the template to customize and override the default',
        placeholder: 'Select a default template'
      },
      subject: {
        label: 'Subject',
        hint: 'Subject of the email. You can use variables.',
        placeholder: 'Enter a subject'
      },
      title: {
        label: 'Main title',
        hint: 'This is the main title in the email body',
        placeholder: 'Enter the main title'
      },
      paragraph: {
        label: 'Paragraphs',
        hint: 'These are the paragraphs of the custom email. HTML is supported.',
        placeholder: 'Fill with a custom text or html',
        openDocs: 'Click here to open the docs',
        position: 'Paragraph position',
        addNew: 'Add paragraph',
      }
    }
  },
  es: {
    betaAlertTitle: 'Función en beta',
    betaAlertDescription: 'La función de plantillas personalizadas está en estado beta, lo que significa que la documentación puede no estar completamente disponible, pero es estable y segura en operación.',
    form: {
      name: {
        label: 'Nombre de la plantilla',
        hint: 'Nombre interno de la plantilla',
        placeholder: 'Ingresa un nombre para la plantilla',
      },
      slug: {
        label: 'ID de integración',
        hint: 'ID de integración para operar con Webhooks',
        placeholder: 'Ingresa un ID de integración'
      },
      template: {
        label: 'Plantilla para personalizar',
        hint: 'Esta será la plantilla para personalizar y sobrescribir la predeterminada',
        placeholder: 'Selecciona una plantilla predeterminada'
      },
      subject: {
        label: 'Asunto',
        hint: 'Asunto del correo electrónico. Puedes utilizar variables.',
        placeholder: 'Ingresa un asunto'
      },
      title: {
        label: 'Título principal',
        hint: 'Este es el título principal en el cuerpo del correo electrónico',
        placeholder: 'Ingresa el título principal'
      },
      paragraph: {
        label: 'Párrafos',
        hint: 'Estos son los párrafos del correo electrónico personalizado. Se admite HTML.',
        placeholder: 'Llena con un texto personalizado o HTML',
        openDocs: 'Haz clic aquí para abrir la documentación',
        addNew: 'Agregar párrafo',
      }
    }
  },
  fr: {
    betaAlertTitle: 'Fonction en bêta',
    betaAlertDescription: 'La fonction de modèles personnalisés est en état bêta, ce qui signifie que la documentation peut ne pas être entièrement disponible, mais elle est stable et sécurisée en fonctionnement.',
    form: {
      name: {
        label: 'Nom du modèle',
        hint: 'Nom interne du modèle',
        placeholder: 'Entrez un nom pour le modèle',
      },
      slug: {
        label: 'ID d\'intégration',
        hint: 'ID d\'intégration pour fonctionner avec les Webhooks',
        placeholder: 'Entrez un ID d\'intégration'
      },
      template: {
        label: 'Modèle à personnaliser',
        hint: 'Ceci sera le modèle à personnaliser et à remplacer le modèle par défaut',
        placeholder: 'Sélectionnez un modèle par défaut'
      },
      subject: {
        label: 'Sujet',
        hint: 'Sujet de l\'e-mail. Vous pouvez utiliser des variables.',
        placeholder: 'Entrez un sujet'
      },
      title: {
        label: 'Titre principal',
        hint: 'Ceci est le titre principal dans le corps de l\'e-mail',
        placeholder: 'Entrez le titre principal'
      },
      paragraph: {
        label: 'Paragraphes',
        hint: 'Ce sont les paragraphes de l\'e-mail personnalisé. HTML est pris en charge.',
        placeholder: 'Remplissez avec un texte personnalisé ou du HTML',
        openDocs: 'Cliquez ici pour ouvrir la documentation',
        addNew: 'Ajouter un paragraphe',
      }
    }
}

}
